import React, {useContext, useState} from 'react';
import styled from 'styled-components/macro';
import LessonNavigatorContainer from '../containers/LessonNavigatorContainer';
import PropertySheetContainer from '../containers/PropertySheetContainer';
import { CheckboxField } from '../components/PropertySheets/UI';
import Splitter from '../components/ui/Splitter';
import { sizes } from '../modules/defines/style';
import SelectContext from '../modules/contexts/selection';
import Button from "@material-ui/core/Button";
import EditorContext from '@mirinae/lessons/editor/modules/contexts/editor';

const PageWrapper = styled.div`
    height: ${sizes.lessonEditor}px;
`;

const OptionsRow = styled.div`
  display: flex;
  flex-direction: row;
  border-bottom: thin solid #adadad;
  justify-content: end;
  // padding: margin: 4px 0 0 4px;
`;

const OpenSpecBox = styled.button`
    margin: 5px 100px 3px 0;
    color: #6a6a6a;
    border: thin solid #cacaca;
    font-size: 11px;
    border-radius: 3px;
    background-color: #f0f0f0;
    :hover {
        background-color: lightgray;
    }
`;

const LessonEditor = () => {
    const [topPane, setTopPane] = useState(null);
    const [bottomPane, setBottomPane] = useState(null);
    const selection = useContext(SelectContext);
    const editor = useContext(EditorContext);

    return (
        <PageWrapper>
            <OptionsRow>
                <OpenSpecBox variant="outlined" size="small" onClick={() => editor.update({ lessonSpecBox: { show: true }})}>Open spec</OpenSpecBox>
                <CheckboxField
                    label="Follow selection in player" checked={selection.followInPlayer} onChange={e => selection.update({ followInPlayer: e.target.checked })}
                    style={{ margin: '4px 0 0 10px' }} />
                <CheckboxField
                    label="Auto-collapse others" checked={selection.autoCollapseOthers} onChange={e => selection.update({ autoCollapseOthers: e.target.checked })}
                    style={{ margin: '4px 0 0 10px' }} />
            </OptionsRow>
            <LessonNavigatorContainer setRef={setTopPane} />
            <Splitter topPane={topPane} bottomPane={bottomPane} />
            <PropertySheetContainer setRef={setBottomPane} />
        </PageWrapper>
    );
};

export default LessonEditor;
